import clsx from "clsx";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
    strike: {
        margin: 0,
        "&::after": {
            top: "35%",
        }
    },
    "@media screen and (max-width:760px)": {
        strike: {
            "&::after": {
                top: "35%",
                height: "10px",
            }
        },
    }
})

function StrikeThrough({
    children
}) {
    const classes = useStyles();

    return (
        <div className={clsx("strike-primary width-max-content", classes.strike)}>
            {children}
        </div>
    )
}

export default StrikeThrough;